<template>
  <q-dialog :ref="$options.name" no-esc-dismiss no-backdrop-dismiss>
    <q-card>
      <q-card-section class="flex items-center justify-start">
        <q-icon
          v-if="icon.length > 0"
          :name="icon"
          color="primary"
          size="45px"
          class="q-mr-sm"
          :class="iconClass"
        />
        <div>
          <h5 v-html="header" />
          <p
            v-if="subHeader.length > 0"
            v-html="subHeader"
            class="text-font-secondary"
          />
        </div>
      </q-card-section>

      <q-card-section class="q-pt-none" v-html="message" />

      <slot name="content" />

      <q-card-section v-if="includeConfirmationInput">
        <q-input
          filled
          v-model="confirmationInput"
          label="Type CONFIRM to continue"
          lazy-rules
          :rules="[
            val => (val && val == 'CONFIRM') || 'Type CONFIRM to continue.'
          ]"
          :disable="submitting || forceSubmitting"
        />
      </q-card-section>

      <q-card-actions align="between" class="q-gutter-x-md q-pa-md">
        <span v-if="hideSecondaryButton"></span>
        <q-btn
          v-else
          flat
          @click="handleCancelClick"
          :label="secondaryButtonLabel"
          color="subtle"
          v-close-popup
          :disable="submitting || forceSubmitting"
        />

        <span v-if="hidePrimaryButton"></span>
        <q-btn
          v-else
          @click="handleOkClick"
          :label="buttonLabel"
          :color="buttonColor"
          :disable="
            submitting ||
              forceSubmitting ||
              (includeConfirmationInput && confirmationInput !== 'CONFIRM')
          "
          :loading="submitting || forceSubmitting"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  name: "ConfirmationModal",
  props: {
    header: {
      type: String,
      required: true
    },
    subHeader: {
      type: String,
      default: ""
    },
    message: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
    iconClass: {
      type: String,
      default: ""
    },
    buttonColor: {
      type: String,
      default: "primary"
    },
    buttonLabel: {
      type: String,
      default: "Confirm"
    },
    secondaryButtonLabel: {
      type: String,
      default: "Cancel"
    },
    hideSecondaryButton: {
      type: Boolean,
      default: false
    },
    hidePrimaryButton: {
      type: Boolean,
      default: false
    },
    includeConfirmationInput: {
      type: Boolean,
      default: false
    },
    forceSubmitting: {
      type: Boolean,
      default: false
    }
  },
  emits: ["ok", "hide"],
  data() {
    return {
      submitting: false,
      confirmationInput: ""
    };
  },
  methods: {
    show() {
      this.$refs[this.$options.name].show();
    },
    hide() {
      this.$refs[this.$options.name].hide();
    },
    handleOkClick() {
      if (this.includeConfirmationInput && this.confirmationInput !== "CONFIRM")
        return;
      this.$emit("ok", this);
    },
    handleCancelClick() {
      this.$emit("hide", this);
    }
  }
};
</script>

<style scoped lang="scss"></style>
